<template>
  <div>
    <h1>List of Current Buckets</h1>

    <div class="row">
      <div class="col-sm">
        <b-table hover small responsive show-empty
          :fields="fields"
          :items="bucketList"
          :busy="isLoading">

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No buckets found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>        
        </b-table>
      </div>
    </div>

  </div>
</template>

<script>
  import config from '@/config'
  import axios from 'axios';
  import axiosRetry from 'axios-retry';

  axiosRetry(axios, { retries: 3 });

  export default {
    data: () => ({
      isLoading: false,

      fields: [
        {key: 'businessName', sortable: true, label: 'Bucket Name'},
        {key: 'ownership', sortable: true, label: 'Owner'},
      ],
      bucketList: [],
    }),

    created () {
      this.initialize()
    },

    computed: {
      formTitle () {
        return 'List of Current Buckets'
      }
    },



    methods: {
      fetchBucketList() {
          axios.get(`${config.CLOUDDRIVE_API_ENDPOINT}buckets/all/public`)
            .then(response => {
                this.bucketList = response.data
                this.isLoading = false
            })
      },

      initialize() {
          this.isLoading = true
          this.fetchBucketList()
      },

    }
  }
</script>